import React from 'react';
import Spinner from './Spinner';

export default function LoadingPage(): JSX.Element {
  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Spinner style={{ fontSize: '25vh', color: 'whitesmoke' }} />
    </div>
  );
}
